import { BreadcrumbItem, Page } from '@acme/foundation';
import { Card } from 'flowbite-react';
import { ReactNode } from 'react';

interface ApplicationPageWrapperProps {
  children: ReactNode;
  breadcrumbItems: BreadcrumbItem[];
  isLoading: boolean;
  isFound: boolean;
}

export const ApplicationPageWrapper = ({
  breadcrumbItems,
  children,
  isLoading,
  isFound,
}: ApplicationPageWrapperProps) => {
  if (isLoading) {
    return (
      <Card>
        <div className="p-6 text-center">Загрузка...</div>
      </Card>
    );
  }

  if (!isFound && !isLoading) {
    return (
      <Card>
        <div className="p-6 text-center">Заявка не найдена</div>
      </Card>
    );
  }

  return <Page breadcrumbItems={breadcrumbItems}>{children}</Page>;
};
